import styled, { css } from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { Dropdown } from '@yme/atoms/dropdown';
import { Link } from '@yme/components/Link';
import { colorCoreGray500, colorCoreBackground1000, colorCoreBlack900Base, } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel4, RegularTextLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const CartItemStyled = styled.div `
  display: flex;
  margin-top: ${INDENT.sm};
  padding-bottom: ${INDENT.sm};
  border-bottom: 1px solid ${colorCoreGray500};

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  ${ADAPTIVE.minWidth.tablet} {
    margin-top: ${INDENT.m};
    padding-bottom: 0;
    border-bottom: none;
  }
`;
export const ImageWrapper = styled.div `
  width: 68px;
  height: 68px;
  flex-shrink: 0;
  box-sizing: border-box;
  border: 1px solid ${colorCoreGray500};
  ${({ isRightToLeft }) => isRightToLeft ? `margin-left: ${INDENT.xs};` : `margin-right: ${INDENT.xs};`}

  ${ADAPTIVE.minWidth.tablet} {
    ${({ isRightToLeft }) => isRightToLeft ? `margin-left: ${INDENT.sm};` : `margin-right: ${INDENT.sm};`}
  }

  ${({ isImageError }) => isImageError &&
    css `
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${colorCoreBackground1000};
    `}
`;
export const Image = styled.img `
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
export const DeleteButton = styled(Button) `
  margin-top: -6px;
  margin-bottom: -6px;

  ${ADAPTIVE.minWidth.tablet} {
    margin: ${({ isRightToLeft }) => isRightToLeft ? `0 ${INDENT.xs} 0 0;` : `0 0 0 ${INDENT.xs};`};
  }
`;
export const DropdownWrapper = styled.div `
  width: 68px;

  ${ADAPTIVE.minWidth.tablet} {
    width: 78px;
    ${({ isRightToLeft }) => isRightToLeft ? `margin-right: ${INDENT.xs};` : `margin-left: ${INDENT.xs};`}
  }
`;
export const PriceWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-self: center;

  text-align: ${({ isRightToLeft }) => (isRightToLeft ? 'left;' : 'right;')}
    ${ADAPTIVE.minWidth.tablet} {
    width: 112px;
    ${({ isRightToLeft }) => isRightToLeft ? `margin-right: ${INDENT.xs};` : `margin-left: ${INDENT.xs};`}
  }
`;
export const Price = styled(HeadingLevel4) `
  width: 100%;
  ${getTextStyles(null, null, 18, 24)}
`;
export const LinkStyled = styled(Link) `
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    text-decoration-color: ${colorCoreBlack900Base};
  }
`;
export const ProductNameStyled = styled(RegularTextLevel3) `
  word-break: break-all;
`;
export const DropdownStyled = styled(Dropdown) `
  input {
    width: 100%;
  }
`;
